
import React, { useEffect, useState } from "react";
import axios from "axios";
import { isAutheticated } from "../auth/authhelper";
import { API } from "../../API";
import { useHistory, Link } from "react-router-dom";

export default function Commission_Payment() {
    const history = useHistory();
    const { token } = isAutheticated();

    const [payments, setPayments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 15;
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    // Navigate to a specific Commission Invoice view
    const handleViewInvoice = (payment) => {
        history.push(`/commission/invoice/${payment._id}`);
    };

    // Fetch commission invoices from backend
    const fetchCommissionInvoices = async (page = 1) => {
        try {
            setLoading(true);
            const res = await axios.get(`${API}/api/invoices/commission_Invoices`, {
                params: {
                    page,
                    limit: rowsPerPage,
                },
                headers: { Authorization: `Bearer ${token}` },
            });

            if (res.data) {
                console.log("vvvvvv", res.data)
                setPayments(res.data.invoices || []);
                setTotalPages(res.data.pages || 1);
            }
        } catch (err) {
            console.error("Error fetching commission invoices:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCommissionInvoices(currentPage);
    }, [currentPage]);

    const handlePageChange = (page) => setCurrentPage(page);

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Video Popup Click Commissions</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><Link to="/dashboard">SoComOTT</Link></li>
                                        <li className="breadcrumb-item active">Video Popup Click Commissions</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className="table-responsive">
                                    <table className='table table-centered table-nowrap mb-0'>
                                        <thead className='thead-light'>
                                            <tr className="text-center">
                                                <th>#</th>
                                                <th>Click Serial No.</th>
                                                <th>Product</th>
                                                <th>Channel</th>
                                                <th>Type</th>
                                                <th>Invoice No.</th>
                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="9" className="text-center py-4">
                                                        <p className="mt-2">Loading commission invoices...</p>
                                                    </td>
                                                </tr>
                                            ) : payments.length > 0 ? (
                                                payments.map((p, idx) => (
                                                    <tr key={p._id} className="text-center">
                                                        <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                                                        <td>{p.Product_popUp_clickId?.serialNumber}</td>

                                                        <td className="font-weight-medium">{p.Product_popUp_clickId?.productName || "N/A"}</td>
                                                        <td>{p.payment_CommissionTo === "channel" ? p.subchannelName : p.network_channelName || "—"}</td>
                                                        <td>
                                                            <span className="">{p.payment_CommissionTo}</span>
                                                        </td>
                                                        <td>{p.invoiceNumber}</td>
                                                        <td>
                                                            {new Date(p.createdAt).toLocaleDateString("en-US", {
                                                                day: "2-digit", month: "short", year: "numeric"
                                                            })}
                                                        </td>
                                                        <td className="">
                                                            {/* {p.currency === "usd" ? "$" : p.currency?.toUpperCase()}${p.amount} */}
                                                            {p.CurrencySymbole ? p.CurrencySymbole : "$"}{p.amount}
                                                        </td>
                                                        <td>
                                                            <span className={`badge ${p.status === "paid" ? "bg-success" : "bg-warning"}`}>
                                                                {p.status}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() => handleViewInvoice(p)}
                                                            >
                                                                View Invoice
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="9" className="text-center py-3">No commission invoices found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                {totalPages > 1 && !loading && (
                                    <nav className="mt-4">
                                        <ul className="pagination justify-content-center">
                                            {[...Array(totalPages)].map((_, i) => (
                                                <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                                    <button className="page-link" onClick={() => handlePageChange(i + 1)}>
                                                        {i + 1}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </nav>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}